<template>
    <div>
        
        <BreadCrumbs v-bind:bcrumbs="bcrumbs" />

        <PageTitle v-bind:title="title" v-bind:admin="true" />


        <div class="alert alert-danger" v-if="errors.load">
            {{ errors.load }}
        </div>       
        <Loader v-if="loading" />
        <div v-else-if="data.question.id">
            <h3>{{data.question.name}}</h3>
            <!-- <p>Состояние Главы: <span v-bind:class="{ 'text-success': data.chapterstate.id == 5, 'text-muted': data.chapterstate.id == 1 }" style="font-weight: bold;">{{ data.chapterstate.name }}</span></p> -->
            <p class="mt-5">Текст вопроса:</p>
            <p v-html="data.question.text" class="mt-4 bg-light shadow p-3 mb-5 rounded"></p>
            <!--
                это не нужно!
            <p><img style="width:64px;" title="Финальная Глава" v-if="data.chapter.is_final" src="/icons/finish.png" alt="Финальная Глава"></p>
            -->
            


            




            <div class="alert alert-danger" v-if="errors.any">
                {{ errors.any }}
            </div>
        </div>





    </div>
</template>
<script>
import axios from 'axios'
import Loader from '@/components/Loader'
import PageTitle from '@/components/PageTitle'
import BreadCrumbs from '@/components/BreadCrumbs'
//import jQuery from 'jquery'
export default {
    data() {
        return {
            loading: true,
            data: [],
            errors: {load: '', any: '', validation: ''},
            title: 'Просмотр вопроса',
            bcrumbs: [],
        }
    },
   async mounted() {
       this.loadData()
    },
    methods: {


        //
        // Переносы из textarea конвертим в переносы для абзаца.
        //
        brFunc(str) {
            if (str) {
                return str.replace(/\n/g, "<br />")
            }
        },

        async loadData() {
            this.errors.load = ''
            try {
                this.loading = true
                let response = await axios.get('admin/questions/'+this.$route.params.id+'/show')
                this.data = response.data
                this.bcrumbs = response.data.bcrumbs
                this.loading = false
            }
            catch (e) {
                if (e.response.status == 520) {
                    this.errors.load = e.response.data.error
                }
                else if (e.response.status == 401) {
                    this.errors.load = e.response.data.error
                }
                else {
                    this.errors.load = 'Ошибка при загрузке данных'
                }
            }
        },


    },
    components: {
        Loader,
        PageTitle,
        BreadCrumbs
    }
}
</script>